import {WCBaseComponent} from './WCBaseComponent.js';

const template = document.createElement('template');

template.innerHTML = `
  <div class="wc-list-table-container overflow-x-auto bg-white rounded shadow-sm">
    <table class="wc-list-table table table-hover">
      <thead>
        <tr>
          <th class="wc-list-table-th"></th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="wc-list-table-td"></td>
          <td class="wc-list-table-td-start informacao"></td>
          <td class="wc-list-table-td-middle"></td>
          <td class="wc-list-table-td-end text-end-1 text-nowrap"></td>
        </tr>
      </tbody>
    </table>
  </div>
`;

export class WCListTableContainer extends WCBaseComponent {

  constructor () {
    super();
  }

  render () {
    let contentNodes = [...this.childNodes];
    let clone = template.cloneNode(true);
    let wcListTableContainer = clone.content.querySelector('.wc-list-table-container').cloneNode(false);
    contentNodes.forEach(node => {
      wcListTableContainer.append(node);
    });
    // this.innerHTML = '';
    this.replaceWith(wcListTableContainer);
  }

}

export class WCListTable extends WCBaseComponent {

  constructor () {
    super();
  }

  render () {
    let contentNodes = [...this.childNodes];
    let clone = template.cloneNode(true);
    let wcListTable = clone.content.querySelector('.wc-list-table').cloneNode(false);
    contentNodes.forEach(node => {
      wcListTable.append(node);
    });
    // this.innerHTML = '';
    this.replaceWith(wcListTable);
  }

}

export class WCListTableTh extends WCBaseComponent {

  constructor () {
    super();
  }

  render () {
    let contentNodes = [...this.childNodes];
    let clone = template.cloneNode(true);
    let wcListTableTh = clone.content.querySelector('.wc-list-table-th').cloneNode(false);
    let wcListTableThIcon = document.createElement('i');
    let dataContext = this.getAttribute('data-context');
    this.classList.forEach(className => {
      wcListTableTh.classList.add(className);
    });
    switch (dataContext) {
    case 'start':
      wcListTableThIcon.classList.add('bi-info-circle');
      wcListTableTh.classList.add('informacao');
      wcListTableTh.append(wcListTableThIcon);
      break;
    case 'end':
      wcListTableThIcon.classList.add('bi-tools');
      wcListTableTh.classList.add('text-end');
      wcListTableTh.append(wcListTableThIcon);
      break;
    case 'middle':
    default:
      contentNodes.forEach(node => {
        wcListTableTh.append(node);
      });
      break;
    }
    // this.innerHTML = '';
    this.replaceWith(wcListTableTh);
  }

}

export class WCListTableTd extends WCBaseComponent {

  constructor () {
    super();
  }

  render () {
    let contentNodes = [...this.childNodes];
    let clone = template.cloneNode(true);
    let wcListTableTd = clone.content.querySelector('.wc-list-table-td').cloneNode(false);
    let dataContext = this.getAttribute('data-context');
    this.classList.forEach(className => {
      wcListTableTd.classList.add(className);
    });
    switch (dataContext) {
    case 'start':
      wcListTableTd.classList.add('informacao');
      break;
    case 'end':
      wcListTableTd.classList.add('text-end', 'text-nowrap');
      break;
    case 'middle':
    default:
      break;
    }
    contentNodes.forEach(node => {
      wcListTableTd.append(node);
    });
    // this.innerHTML = '';
    this.replaceWith(wcListTableTd);
  }

}